import { Alert, Card, CardBody } from "reactstrap";
import WizardPanel from "../WizardPanel";

/** @param {import("../WizardCard").StepPanelProps} props */
export default function WaitingForVeesionPanel({ installation, status, bottomNav }) {
  const submittedAt = installation?.submitted_at;
  const submittedLabel = submittedAt ? new Date(submittedAt).toLocaleString() : null;

  return (
    <WizardPanel
      title="Quality Review"
      subtitle="Waiting for Veesion's Quality Control team to validate the streams"
      status={status}
      bottomNav={bottomNav}
    >
      <Alert color="info">
        <i className="fas fa-comment-alt mr-2" />
        <strong>Quality Control team has been notified on Slack.</strong>
        <div className="small mt-1">
          A threaded message was posted on the <code>#installation</code> channel when you applied the configuration.
          The QC team will review the streams and tag this installation as validated once the algorithm is happy.
          {submittedLabel && <div className="text-muted mt-1">Notification sent at {submittedLabel}.</div>}
        </div>
      </Alert>

      <Card>
        <CardBody className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
          <i className="fas fa-hourglass-half text-warning" />
          <div className="flex-grow-1">
            <div className="font-weight-bold">Quality review in progress</div>
            <small className="text-muted">
              Click <strong>Quality Control Validated</strong> below once QC has signed off. No automatic check; trust
              the human decision.
            </small>
          </div>
        </CardBody>
      </Card>
    </WizardPanel>
  );
}
